import React, { ComponentType, FunctionComponent } from 'react';

import { DataTableCellProps } from 'components/dataTable/dataTable.types';

import { COLUMN_IDS } from '../../keys';
import { ActionsCell } from './actionsCell';
import { CurrencyCell } from './currencyCell';
import { DateCell } from './dateCell';
import { DefaultCell } from './defaultCell';

const cellComponentMap: { [key: string]: ComponentType<DataTableCellProps> } = {
  [COLUMN_IDS.TYPE]: DefaultCell,
  [COLUMN_IDS.SOURCE_ID]: DefaultCell,
  [COLUMN_IDS.CREATED_AT]: DateCell,
  [COLUMN_IDS.AMOUNT]: CurrencyCell,
  [COLUMN_IDS.PROCESSING_FEE]: CurrencyCell,
  [COLUMN_IDS.ACTIONS]: ActionsCell,
  default: DefaultCell,
};

export const TransactionCell: FunctionComponent<DataTableCellProps> = (props) => {
  const { column } = props;
  const SelectedComponent = cellComponentMap[column.id] || cellComponentMap.default;

  return <SelectedComponent {...props} />;
};
